<template>

  <div id="app" :class="{showMenu: $store.getters.isMenuVisible(this.$route), showHeader: $store.getters.isHeaderVisible(this.$route), mobile: isMobile}">

    <template v-if="isDesktop">
      <Banner />
      <div class="logo" :class="{hidden: !$store.getters.isMenuVisible(this.$route) || !$store.getters.isHeaderVisible(this.$route)}">
        <svgicon src="icon/close-menu.svg" :width="20" :height="20"></svgicon>
        Hello{{ getUserName ? ", " + getUserName : " " }}!
      </div>
      <Header />
      <Navigation />
    </template>

    <template v-if="isMobile && $store.getters.isHeaderVisible(this.$route)">
      <MobileNavigation/>
      <MobileHeader/>
    </template>

    <div class="appcontent">
      <StagingDisclaimer v-if="showStagingDisclaimer" :view-ref="this.$refs.view" />
      <router-view ref="view" :key="$route.fullPath" :class="{mobile: isMobile, showHeader: $store.getters.isHeaderVisible(this.$route)}"/>
    </div>

    <div id="spinner" class="spinner" :class="{show: $store.state.showSpinner}">
      <img src="./assets/img/spinner.png">
    </div>

    <div class="toasts"></div>

    <div id="modalConfirmation" class="modal">
      <div class="modal-content">
        <div class="modal-header"></div>
        <div class="modal-body">
          <div class="content"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary modal-no">{{ $t('no') }}</button>
          <button type="button" class="btn btn-primary modal-yes">{{ $t('yes') }}</button>
        </div>
      </div>
    </div>

    <div id="modalAffirmation" class="modal">
      <div class="modal-content">
        <div class="modal-header"></div>
        <div class="modal-body">
          <div class="content"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary modal-ok">{{ $t('ok') }}</button>
        </div>
      </div>
    </div>

    <div id="modalUpdateDownload" class="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header justify-content-center"></div>
          <div class="modal-body">
            <span class="current"></span>Mb {{$t('of')}} <span class="total"></span>Mb {{$t('downloaded')}}...
            <br><br>
            <div class="progressBar">
              <div class="inner"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal name="file-type-image-error" :title="$t('error.title')" :actions="[{name: $t('back'), action: 'close'}]">
      {{ $t('error.file_type_image') }}
    </Modal>

    <Modal name="file-type-video-error" :title="$t('error.title')" :actions="[{name: $t('back'), action: 'close'}]">
      {{ $t('error.file_type_video') }}
    </Modal>

    <Modal name="file-type-document-error" :title="$t('error.title')" :actions="[{name: $t('back'), action: 'close'}]">
      {{ $t('error.file_type_document') }}
    </Modal>

    <Modal name="file-size-error" :title="$t('error.title')" :actions="[{name: $t('back'), action: 'close'}]">
      {{ $t('error.file_size') }}
    </Modal>

    <!--<Modal name="new-ui" :title="$t('new_ui.title')" :actions="[{name: $t('continue'), action: 'close'}]">
      <div class="new-ui-popup">
        <img src="@/assets/img/new-ui.png" alt="new ui image">
        <div style="text-align: center;">{{ $t('new_ui.description') }}</div>
      </div>
    </Modal>-->

    <Modal name="component-modal"
           v-bind="$store.state.modalProps"
           :actions="[{name: $t('back'), action: 'close'}]">
      <component :is="$store.state.modalComponent" v-bind="$store.state.modalComponentProps" />
    </Modal>

  </div>

</template>

<script>
  import Header from './components/Header.vue';
  import Navigation from './components/Navigation.vue';
  import MobileHeader from './components/MobileHeader.vue';
  import MobileNavigation from './components/MobileNavigation.vue';
  import StagingDisclaimer from "@/components/inventory/StagingDisclaimer";
  import { LocalStorage } from './resources/localStorage';
  import { Core } from "./core/Core";
  import { mapActions } from "vuex";
  import * as VeloceXml from "@/resources/veloce";
  import Banner from './components/Banner.vue';

  export default {

    name: 'app',

    components: {
      Navigation,
      MobileNavigation,
      Header,
      MobileHeader,
      Banner,
      StagingDisclaimer
    },

    beforeCreate() {
      let user = LocalStorage.read("user");
      if (user && user.token && !this.$store.getters.isTokenExpired) {
        let contextServer = LocalStorage.read("context-server");
        this.$store.commit('logIn', user);
        this.$store.commit('setContextServer', contextServer);
        if (this.$route.name === 'login') {
          let defaultRouting = this.$store.getters.defaultRouting;
          this.$router.replace(defaultRouting)
        }
      } else {
        let loadedUser = false;
        if (isExecutable()) {
          let fs = nw.require("fs");
          fs.readFile(Parameters.userConfigPath, "utf8", async (err, token) => {
            if (!err) {
              loadedUser = true;
              Core.setLoginToken(token);
              try {
                let user = await Core.request("GET", "/api/me2?augment=admin");
                this.$store.commit('setUser', user);
                this.$store.commit('setContextServer', user.homeServer);
                if (this.$route.name === 'login') {
                  let defaultRouting = this.$store.getters.defaultRouting;
                  this.$router.replace(defaultRouting);
                }
              } catch (e) { }
            }
          });
        }

        if (!loadedUser) {
          let aclExceptions = ["resetpassword"];
          this.$store.commit("logOut");
          if (!aclExceptions.includes(this.$route.name) && this.$route.name !== 'login') {
            this.$router.push("/login");
          }
        }
      }

      this.$store.commit("setContext", { branchId: this.$route.query.branch, companyId: this.$route.query.company, hardRefresh: true });
    },

    async created() {
      this.setPrimaryColor("#fc6650");
      this.setSecondaryColor("#ed2937");
      this.initLocaleFromCache();
    },

    async mounted() {
      this.branch = await this.$store.getters.getContextBranch;
      await this.checkIfSendingSaleToPos();
    },

    data() {
      return {
        companyPingInterval: null,
        salesPollingInterval: null,
        salesPollingBusy: false,
        maximumRetry: 100,
        salesPollingIntervalDelay: 30, //seconds,
        retryMaitreDFailedSale: false,
        sendingSalesToMaitrePos: false,
        maitrePosUrl: "http://localhost/MDProxyWebService/MDProxyService.asmx?wsdl",
        branch: null,

        sendingSalesToVeloce: false,
        veloceConfig: null,
        viewHasStagingEdit: false
      }
    },

    computed: {
      isMobile() {
        return this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md';
      },
      isDesktop() {
        return this.$mq === 'lg' || this.$mq === 'xl';
      },
      isBranchInventory() {
        return this.$store.getters.isBranchContextInventory;
      },
      company() {
        return this.$store.state.contextCompany;
      },
      loggedUser() {
        return this.$store.state.loggedUser;
      },
      inventory() {
        return this.$store.state.contextInventory;
      },
      showStagingDisclaimer() {
        return this.viewHasStagingEdit && !!this.$store.state.contextVersion;
      },
      getUserName() {
        if (this.$store.state.loggedUser && this.$store.state.loggedUser.user) {
          if (this.$store.state.loggedUser.user.firstName && this.$store.state.loggedUser.user.lastName) {
            return this.$store.state.loggedUser.user.firstName + " " + this.$store.state.loggedUser.user.lastName;
          }
          if (this.$store.state.loggedUser.user.email) {
            return this.$store.state.loggedUser.user.email;
          }
        }
        return "";
      }
    },

    watch: {
      $route: {
        immediate: true,
        async handler() {
          this.$nextTick(() => {
            this.viewHasStagingEdit = this.$refs.view && this.$refs.view.version !== undefined;
          });
        }
      },
      company: async function() {
        await this.checkIfSendingSaleToPos();
        this.startAllPollings();
      },
      loggedUser: {
        immediate: true,
        handler: async function() {
          await this.checkIfSendingSaleToPos();
          this.startAllPollings();
        }
      }
    },

    beforeDestroy() {
      this.clearCompanyPingInterval();
      this.clearSalesPollingInterval();
    },

    methods: {
      ...mapActions(["screenPendingSales", "getCompanyExternalPos", "updateSaleStatus", "screenConfirmSale"]),

      setPrimaryColor(color) {
        document.documentElement.style.setProperty("--primary-color",color);
      },
      setSecondaryColor(color) {
        document.documentElement.style.setProperty("--secondary-color",color);
      },
      initLocaleFromCache() {
        let locale = localStorage.getItem("ishopv3-backend-locale");
        if (locale) {
          this.$ts.commit('setLocale', locale)
        }
      },
      clearCompanyPingInterval() {
        if (this.companyPingInterval) {
          clearInterval(this.companyPingInterval);
          this.companyPingInterval = null;
        }
      },
      clearSalesPollingInterval() {
        this.$store.state.sales = [];
        if (this.salesPollingInterval) {
          clearInterval(this.salesPollingInterval);
          this.salesPollingInterval = null;
        }
      },

      startAllPollings() {
        /* reception */
        if ((this.loggedUser &&  this.company && (isExecutable() || this.loggedUser.isReceptionUser || this.loggedUser.isClerkUser || this.loggedUser.isPosUser))
          || (this.loggedUser && !this.company && this.loggedUser.isReceptionUser)
        ) {
          this.startSalesPolling();
        } else {
          this.clearSalesPollingInterval();
        }

        if (this.company) {
          this.startCompanyPingPolling();
        } else {
          this.clearCompanyPingInterval();
        }
      },

      isTunnelConfiguration(posData) {
        if (posData.selected[0] === "maitre" && posData.maitre) {
          return posData.maitre.url.includes("tunnel");
        } else if (posData.selected[0] === "veloce" && posData.veloce) {
          return posData.veloce.host.includes("tunnel");
        } else {
          return false;
        }
      },
      maitreActivated(company) {
        return company && company.activePOS && company.activePOS.includes('maitre')
      },
      veloceActivated(company) {
        return company && company.activePOS && company.activePOS.includes('veloce')
      },
      /**
       * Create an interval and support external pos ping
       * Will restart ssh tunnel if connection is not working
       */
      startCompanyPingPolling() {
        if (isExecutable() && this.loggedUser && this.company) {
          this.clearCompanyPingInterval();
          let pingInterval = this.company.pingInterval ? this.company.pingInterval : 60000;

          if (this.maitreActivated(this.company) || this.veloceActivated(this.company)) {
            let companyPing = async () => {

              /* Get ping status */
              let status = false;

              try {
                let response = await Core.request('GET', '/api/company/' + this.company.id + '/retry-connexion');
                status = response.active;
                if (response.update) {
                  logToFile("Automatic build update started");
                  window.update({force: true});
                }
                if (!status) {
                  logToFile("POS connexion inactive");
                }
              } catch (e) {
                console.log('Error while sending ping request', e);
                logToFile("/retry-connexion FAIL - " + JSON.stringify(e));
              }

              /* restart tunnel */
              if (!status) {
                try {
                  let externalPosData = await this.getCompanyExternalPos({ companyId: this.company.id, branchId: this.company.branch });
                  if (externalPosData && this.isTunnelConfiguration(externalPosData)) {
                    nw.Shell.openItem(Parameters.tunnelStatusPath);
                    console.log('executed', Parameters.tunnelStatusPath);
                    logToFile("Tunnel restart " + Parameters.tunnelStatusPath);
                  }
                } catch (e) {
                  console.log("error", e);
                }
              }
            };

            companyPing();
            this.companyPingInterval = setInterval(companyPing, pingInterval);
          }
        }
      },

      /**
       * Fetch Sales
       * to push to POS and store for reception screen
       */
      startSalesPolling() {
        this.clearSalesPollingInterval();
        console.log("starting sales polling with delay:", this.salesPollingIntervalDelay);
        let pollSales = async () => {
          /* A Veloce send is awaited inside the loop: never let two polls overlap */
          if (this.salesPollingBusy) {
            return;
          }
          this.salesPollingBusy = true;
          try {
            let buildVersion = this.getBuildVersion();
            let codeVersion = await this.getCodeVersion();
            let response = await this.screenPendingSales({lower: 48, lowerStep: 'hours', buildVersion: buildVersion, version: codeVersion});
            if (response) {

              this.removeSaleToUpdateFromList(response.data.sales.filter(s => s.forceUpdate));

              let newSales = response.data.sales.filter(s => !this.saleWithIdExists(s.id) );
              if (newSales.length > 0) {
                this.$store.state.sales = [...newSales, ...this.$store.state.sales];
                this.$store.state.sales.sort((s1, s2) => s1.expectedDeliveryTime.date < s2.expectedDeliveryTime.date ? -1 : 1);
              }

              for (let sale of this.$store.state.sales) {
                if(sale.posFailed !== false && this.validateNumberOfRetry(sale)) {
                  if (this.sendingSalesToMaitrePos) {
                    this.sendMaitreDSaleToPos(sale);
                  }
                  if (this.sendingSalesToVeloce) {
                    await this.sendSaleToLocalVeloce(sale);
                  }
                }

                // Send sale locally to MD if required
                if (sale.posFailed && this.retryMaitreDFailedSale) {
                  this.sendMaitreDSaleToPos(sale);
                }
              }
            }
          } catch (e) {
            console.log('error while polling sales', e);
          } finally {
            this.salesPollingBusy = false;
          }
        }
        pollSales();
        this.salesPollingInterval = setInterval(pollSales, this.salesPollingIntervalDelay * 1000);
      },

      async getCodeVersion() {
        let response = await fetch("version.txt");
        return await response.text();
      },

      validateNumberOfRetry(sale) {
          return sale.numberOfRetry <= this.maximumRetry;
      },

      async updateStatus(sale) {
        let saleIndex = this.$store.state.sales.indexOf(sale);
        if (!sale.status || sale.status === "pending") {
          let response = await this.screenConfirmSale(sale.id);
          if (response) {
            this.$store.state.sales[saleIndex].status = 'confirmed';
          } else {
            toast(this.$t("error.no_server"), "error");
          }
          this.$forceUpdate();
          this.$refs.view.$forceUpdate();
        }
      },

      getBuildVersion() {
        if (isExecutable()) {
          let fs = nw.require("fs");
          let versionFilePath = 'versionNumber.txt';
          if (fs.existsSync(versionFilePath)) {
            return fs.readFileSync(versionFilePath, 'utf8');
          }
        } else {
          return "";
        }
      },

      saleWithIdExists(saleId) {
        return !!this.$store.state.sales.find(s => s.id === saleId);
      },

      removeSaleToUpdateFromList(salesToRemove) {
        for (let saleToRemove of salesToRemove) {
          let sale = this.$store.state.sales.find(s => s.id === saleToRemove.id);
          let saleIndex = this.$store.state.sales.indexOf(sale);
          console.log('removing sale from list on index', saleIndex);
          this.$store.state.sales.splice(saleIndex, 1);
        }
      },


      async checkIfSendingSaleToPos() {
        if (!this.branch) {
          /* mounted() ran before the context was loaded (saved-token start: the route has no branch yet) */
          this.branch = await this.$store.getters.getContextBranch;
        }
        let company = this.company ? this.company : (this.branch ? this.branch.companies[0] : null);
        if (!company || !this.branch) {
          return;
        }
        let externalPosData = await this.getCompanyExternalPos({ companyId: this.company ? company.id : company, branchId: this.branch.id });
        if (externalPosData) {
          /* Re-derive everything from the current config (the company context can change) */
          this.retryMaitreDFailedSale = false;
          this.sendingSalesToMaitrePos = false;
          this.sendingSalesToVeloce = false;
          this.veloceConfig = null;

          if (externalPosData.selected[0] === 'maitre' && externalPosData.maitre && externalPosData.maitre.retryFailedSaleLocally) {
            this.retryMaitreDFailedSale = true;
            console.log('Retry sale locally activate for MaitreD POS');
          }
          if (externalPosData.selected[0] === 'isfAgentPolling') {
            /* Polling delay and retry cap come from the company config for every polled POS */
            let pollingPos = externalPosData.isfAgentPolling && externalPosData.isfAgentPolling.pos
              ? externalPosData.isfAgentPolling.pos
              : 'maitre';
            let delay = parseFloat(externalPosData.salesPollingIntervalDelay);
            this.salesPollingIntervalDelay = isNaN(delay) ? this.salesPollingIntervalDelay : Math.max(delay, 5);
            if (externalPosData.maximumRetry !== null && externalPosData.maximumRetry !== undefined) {
              this.maximumRetry = externalPosData.maximumRetry;
            }

            if (pollingPos === 'maitre') {
              this.sendingSalesToMaitrePos = true;
              this.maitrePosUrl = externalPosData.maitre.url;
              console.log('Incoming sales sync with maitre pos. Endpoint ' + this.maitrePosUrl + ' Delay: ' + this.salesPollingIntervalDelay);
            }
            if (pollingPos === 'veloce') {
              /* The agent runs inside the restaurant: talk to Veloce on the LAN (localHost/localPort),
                 host/port is the tunnel endpoint the cloud API used and is kept only as a fallback */
              let veloce = externalPosData.veloce || {};
              let host = veloce.localHost || veloce.host;
              let port = parseInt(veloce.localPort || veloce.port, 10);
              if (!host || isNaN(port)) {
                console.log('Veloce polling enabled but no local host/port configured, sales will not be sent', veloce);
                return;
              }
              this.sendingSalesToVeloce = true;
              this.veloceConfig = {
                host: host,
                port: port,
                debug: true
              }
              console.log('Incoming sales sync with veloce pos. Endpoint ' + host + ':' + port + ' Delay: ' + this.salesPollingIntervalDelay + ' Max retry: ' + this.maximumRetry);
            }
          }
        }
      },

      async sendSaleToLocalVeloce(sale) {
        if (!isExecutable()) {
          console.log("not in .exe, cannot send sale");
          return;
        }
        let veloceRequest = sale.veloceXmlRequest;
        if (!veloceRequest) {
          console.log('sale ' + sale.id + ' has no veloceXmlRequest (company not configured for Veloce polling?), skipping');
          return;
        }
        if (sale.sendingToPos) {
          return;
        }
        sale.sendingToPos = true;
        let veloceResponse;
        let veloceMissingProducts = null;
        let success;
        try {
          veloceResponse = await VeloceXml.sendSale({config: this.veloceConfig, payload: veloceRequest})
          let result = VeloceXml.parseResult(veloceResponse);
          /* 0 = posted. 10 = accepted by Veloce but it may not have printed: the order IS in the POS,
             re-sending it would create a duplicate, so it is treated as success and logged. */
          success = result === 0 || result === 10;
          console.log('veloce sale ' + sale.id + ' result ' + result + (success ? '' : ' - ' + VeloceXml.parseResultMsg(veloceResponse)));
          if (result === 10) {
            logToFile('Veloce accepted sale ' + sale.id + ' with Result 10 (possible print problem)');
          }
          if (result === 4) {
            /* "at least one product does not exist", and Veloce does not say which. Diff the order against
               the POS item list (Oper 5): the API swaps those lines for the ghost item and re-sends the sale. */
            try {
              veloceMissingProducts = await VeloceXml.findMissingProducts({config: this.veloceConfig, payload: veloceRequest});
              logToFile('Veloce refused sale ' + sale.id + ' (Result 4), unknown products: ' + veloceMissingProducts.join(', '));
            } catch (listErr) {
              logToFile('Veloce refused sale ' + sale.id + ' (Result 4), item list unavailable: ' + listErr.name + ' ' + listErr.message);
            }
          }
        } catch(err) {
          veloceResponse = `${err.name} ${err.message}`;
          success = false;
          console.log('veloce sale ' + sale.id + ' failed: ' + veloceResponse);
        } finally {
          sale.sendingToPos = false;
        }
        let statusData = {veloceRequest, veloceResponse};
        if (veloceMissingProducts && veloceMissingProducts.length > 0) {
          statusData.veloceMissingProducts = veloceMissingProducts;
        }
        this.saleUpdateStatus(sale, success, statusData);
      },

      sendMaitreDSaleToPos(sale) {
        console.log('sending sale locally to maitre d pos');
        if (!isExecutable()) {
          console.log("not in .exe, cannot send sale");
          return;
        }

        let soap = nw.require('strong-soap').soap;
        let url = this.maitrePosUrl;
        let options = { endpoint: url };

        try {
          soap.createClient(url, options, (error, client) => {
            if (error) {
              console.log('error creating client', error);
              this.sendMaitreDFailStatus(sale, 'error creating client, inspect console for more info');
            }
            client.AddOrder(sale.mdMealZoneSoapRequest, (error, result) => {
              if (error) {
                console.log('error creating client add order', error);
                this.sendMaitreDFailStatus(sale, 'error client add order, inspect console for more info');
              }
              let orderStatus = result.AddOrderResult.orderStatusHeader.orderStatus;
              if (orderStatus == "2") {
                this.sendMaitreDSuccessStatus(sale, orderStatus);
              } else {
                this.sendMaitreDFailStatus(sale, result.AddOrderResult.orderStatusHeader.errorDetail);
              }
            }, {timeout: 5000});
          });
        } catch (e) {
          console.log('error sending sale locally to md', e);
          this.sendMaitreDFailStatus(sale, 'error sending sale locally to md, inspect console for more info');
        }
      },

      sendMaitreDSuccessStatus(sale, orderStatus) {
        console.log('Success order status:', orderStatus);
        this.saleUpdateStatus(sale, true, {
          mdRequest: sale.mdMealZoneSoapRequest,
          mdResponse: {
            status: '200',
            message: orderStatus
          }
        })
        this.updateStatus(sale);
      },

      sendMaitreDFailStatus(sale, error) {
        console.log('Sending Md failed Status' + error)
        this.saleUpdateStatus(sale, false, {
          mdRequest: sale.mdMealZoneSoapRequest,
          mdResponse: {
            status: '500',
            message: 'Error soap connect: ' + error,
          }
        })
      },

      saleUpdateStatus(sale, isSuccess, data) {
        sale.posFailed = !isSuccess;
        sale.numberOfRetry++; /* increment */
        Promise.resolve(Core.request("PUT", "/api/secure/screen/sale-update-status", {
          id: sale.id,
          numberOfRetry: sale.numberOfRetry,
          posFailed: sale.posFailed,
          ...data
        })).catch((e) => {
          console.log('sale-update-status failed for sale ' + sale.id, e);
          logToFile('sale-update-status FAIL sale ' + sale.id + ' - ' + (e && e.status ? e.status : JSON.stringify(e)));
        });
        this.updateStatus(sale);
      }

    }
  };

</script>

<style lang="scss">

  html, body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-family: 'Roboto', sans-serif;
    background-color: #F5F5F5;
    color: #404040;
    box-sizing: border-box;
  }

  * {
    box-sizing: border-box;
  }

  // https://stackoverflow.com/questions/71074/how-to-remove-firefoxs-dotted-outline-on-buttons-as-well-as-links
  :focus {outline: none;}
  ::-moz-focus-inner {border: 0;}

  table {
    border-collapse: collapse;
  }

  #app {
    display: grid;
    grid-template-columns: 300px 1fr;
    grid-template-rows: 48px 48px 1fr;
    height: 100%;
    width: 100%;
    &.mobile {
      display: flex;
      flex-direction: column;
    }
    &:not(.showMenu) {
      grid-template-columns: 1fr;
    }
    &:not(.showHeader) {
      grid-template-rows: 1fr;
    }
  }

  .appcontent {
    overflow: auto;
    padding: 40px;
    & > .container {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      & > #Tabs {
        flex-grow: 1;
      }
    }
    &.mobile {
      padding: 20px 10px;
    }
  }

  .container {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
    hr {
      width: 100%;
    }
  }

  input[type=checkbox] {
    display: none;
    & + label {
      min-height: 20px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      user-select: none;
      margin-left: 20px;
      padding-left: 12px;
      align-items: center;
      justify-content: flex-start;
      display: flex;
      color: #1a1a1a;
      font-size: 16px;
    }
    & + label:before {
      content: "";
      background-color: white;
      width: 20px;
      height: 20px;
      position: absolute;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
      outline: 1px solid transparent;
      box-sizing: border-box;
      left: -20px;
    }
    &:checked + label:before {
      border: 1px solid var(--primary-color);
      outline: 1px solid var(--primary-color);
    }
    &:checked + label:after {
      content: "";
      width: 12px;
      height: 12px;
      background-color: var(--primary-color);
      border-radius: 4px;
      position: absolute;
      top: 50%;
      left: -16px;
      transform: translateY(-50%);
    }
    &:checked.indeterminate + label:after {
      height: 4px;
      border-radius: 0;
    }
  }

  input[type=radio] {
    display: none;
    & + label {
      min-height: 20px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      user-select: none;
      margin-left: 20px;
      padding-left: 12px;
      align-items: center;
      justify-content: flex-start;
      display: flex;
      color: #1a1a1a;
      font-size: 16px;
    }
    & + label:before {
      content: "";
      background-color: white;
      width: 20px;
      height: 20px;
      position: absolute;
      border-radius: 50%;
      border: 1px solid #e6e6e6;
      outline: 1px solid transparent;
      box-sizing: border-box;
      left: -20px;
    }
    &:checked + label:before {
      border: 1px solid var(--primary-color);
      outline: 1px solid var(--primary-color);
    }
    &:checked + label:after {
      content: "";
      width: 12px;
      height: 12px;
      background-color: var(--primary-color);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: -16px;
      transform: translateY(-50%);
    }
    &:checked.indeterminate + label:after {
      height: 4px;
      border-radius: 0;
    }
  }

  .btn {
    border-radius: 6px;
    padding: 8px 12px;
    background-color: white;
    border: none;
    outline: 0 !important;
    color: var(--primary-color);
    font-size: 16px;
    cursor: pointer;
    transition: box-shadow 0.2s ease;
    line-height: 1;
    text-decoration: none;
    &.btn-primary {
      background-color: var(--primary-color);
      color: white;
      .svgicon {
        fill: white;
      }
    }
    &.btn-secondary {
      color: var(--primary-color);
      background-color: #F5F5F5;
      .svgicon {
        fill: var(--primary-color);
      }
    }
    &.btn-outline {
      background-color: transparent;
      border: 1px solid var(--primary-color);
      color: var(--primary-color);
      .svgicon {
        fill: var(--primary-color);
      }
    }
    &.disabled, &:disabled {
      opacity: 0.6;
      pointer-events: none;
    }
  }

  input[type=color] {
    border: solid 1px #d9d9d9;
    width: 100%;
    min-height: 30px;
    padding: 4px;
    border-radius: 4px;
    background-color: white;
  }
  select,
  input[type=text],
  input[type=number],
  input[type=password],
  input[type=email],
  input[type=tel],
  textarea {
    background-color: white;
    padding: 9.5px 14px;
    border: none;
    border-radius: 6px;
    border: solid 1px #d9d9d9;
    font-size: 18px;
    font-family: 'Roboto';
    color: #404040;

    &.small {
      font-size: 12px;
      padding: 6px 8px;
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    &.invalid {
      border-color: #ff0000;
      box-shadow: 0px 1px 0px 0px #ff0000;
    }
  }

  select {
    padding: 8.5px 14px;
  }

  textarea {
    resize: none;
    height: 3.5em;
  }

  label {
    color: #808080;
    font-size: 14px;
    line-height: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .group {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    label {
      margin-bottom: 6px;
    }
  }

  .locked {
    position: relative;
    pointer-events: none;
    user-select: none;
    opacity: 0.3;
  }

  .input-group {
    display: flex;

    input[type=text] {
      flex-grow: 1;
      margin-right: 10px;
    }
  }
  @media (max-width: 575px) {
    .input-group {
      flex-direction: column;
      input[type=text] {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }
  }

  .pointer {
    cursor: pointer;
  }

  .w-100 {
    width: 100%;
  }

</style>

<style lang="scss" scoped>

  .logo {
    background-color: #262626;
    display: flex;
    align-items: center;
    padding-left: 20px;
    fill: #666666;
    color: #BFBFBF;
    .svgicon {
      margin-right: 20px;
    }

    img {
      height: 30px;
      width: auto;
    }
  }

  .spinner {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.4s ease;
    user-select: none;
    background-color: rgba(255, 255, 255, 0.6);
    img {
      animation: spin 2s ease infinite;
      @keyframes spin {
        0% {transform: none;}
        50% {transform: rotateZ(180deg)}
        100% {transform: rotateZ(360deg)}
      }
    }
    &.show {
      opacity: 1;
      pointer-events: all;
    }
  }

</style>


<style lang="scss">
  #app {
    #modalUpdateDownload .progressBar {
      width: 100% !important;
      height: 20px;
      border-radius: 10px;
      overflow: hidden;
      background-color: #888;
    }
    #modalUpdateDownload .progressBar .inner {
      height: 100% !important;
      background-color: var(--primary-color);
    }
    #modalConfirmation, #modalAffirmation, #modalUpdateDownload {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      pointer-events: none;
      & * {
        pointer-events: none;
      }
      transition: opacity 0.3s ease-in-out;
      z-index: 999;
      color: #404040 !important;
      &.show {
        opacity: 1;
        pointer-events: all;
        & * {
          pointer-events: all;
        }
        .modal-content {
          top: 0px;
        }
      }
      .modal-no {
        margin-right: 10px;
      }
      .modal-content {
        background-color: white;
        padding: 32px;
        margin: 20px;
        border-radius: 32px;
        box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.2);
        width: 100%;
        max-width: 400px;
        position: relative;
        top: -40px;
        transition: top 0.3s ease;
        font-size: 16px;
        white-space: pre-wrap;

        .modal-header {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: bold;
          padding-bottom: 32px;
        }
        .modal-footer {
          margin-top: 40px;
          display: flex;
          justify-content: space-between;
          margin-bottom: -10px;
          .btn {
            margin-bottom: 10px;
            flex-shrink: initial;
            padding: 8px 16px;
          }
        }
      }
    }
    .v-select .dropdown-toggle {
      background-color: white;
      padding: 5px;
      border-radius: 4px;
      border: solid 1px #d9d9d9;
      font-family: 'Roboto';
      color: #404040;
      cursor: pointer;
    }
    .v-select .selected-tag {
      margin: 5px;
      height: auto;
      padding: 2px;
      font-size: 16px;
      line-height: 1;
      padding: 8px;
      background-color: #e6e6e6;
      border: none;
      color: #404040;

      .close {
        margin-left: 5px;
        color: #b3b3b3;
        opacity: 1;
        font-size: 24px;
        line-height: 16px;
        vertical-align: top;
        text-shadow: none;
      }
    }
    .v-select input[type=search],
    .v-select input[type=search]:focus {
      height: 30px;
      width: 0 !important;
    }
    .v-select .open-indicator {
      bottom: 8px;
    }
    .v-select .open-indicator:before {
      border-color: #d9d9d9;
    }
    .v-select .dropdown-menu > .highlight > a {
      background-color: var(--primary-color);
    }
  }

  .hidden:not([role=combobox]) {
    display: none !important;
  }

  .page-title {
    font-size: 20px;
    font-weight: bold;
    color: #404040;
    margin-bottom: 20px;
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: flex-end;
    line-height: 1;

    .description {
      font-size: 14px;
      color: #808080;
    }
  }

  .footer-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 20px;
    flex-shrink: 0;

    .grow {
      flex-grow: 1;
    }
  }

  .tabs {
    display: flex;
    flex-wrap: wrap;

    .tab {
      flex-grow: 1;
      display: flex;
      flex-basis: 0;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 16px;
      padding: 10px 18px 8px 18px;
      line-height: 1;
      text-align: center;
      text-decoration: none;
      border-bottom: 5px solid #e6e6e6;
      margin-bottom: 10px;
      transition: border-bottom-color 0.2s ease-in-out;
      color: #808080;

      &.button {
        flex-grow: 0;
        cursor: initial;
        white-space: nowrap;

        &:hover {
          border-color: #e6e6e6;
        }

        &:last-child {
          padding-right: 0;
        }
      }

      &.filler {
        cursor: initial;
        &:hover {
          border-color: #e6e6e6;
        }
      }

      &.active, &.router-link-exact-active {
        color: #404040;
        font-weight: 500;
        border-bottom: 5px solid var(--secondary-color);
        cursor: pointer;
      }
      &:hover {
        border-bottom: 5px solid var(--secondary-color);
      }
      &.disabled {
        color: rgba(128,128,128,0.4);
        pointer-events: none;
      }
    }
  }

  .toasts {

    position: fixed;
    bottom: 0;
    left: 50%;
    width: 100%;
    max-width: 500px;
    padding: 40px 20px;
    pointer-events: none;
    transform: translateX(-50%);
    z-index: 9999;

    .toast {
      background-color: #E2E3E5;
      border: 1px solid darken(#E2E3E5, 5%);
      border-radius: 10px;
      padding: 10px 20px;
      box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
      animation: toast 0.4s ease;
      cursor: pointer;
      pointer-events: all;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: white;
      z-index: 9999;
      &.success {
        background-color: #36d53d;
        border-color: darken(#36d53d, 5%);
      }
      &.warning {
        background-color: #feb055;
        border-color: darken(#feb055, 5%);
      }
      &.error {
        background-color: #ef4244;
        border-color: darken(#ef4244, 5%);
      }
      &.info {
        background-color: #63b4f1;
        border-color: darken(#63b4f1, 5%);
      }
      &.close {
        animation: toast-close 0.4s ease;
      }

      .toast-icon, .close {
        flex-shrink: 0;
      }

      .toast-icon {
        padding-right: 15px;
        margin-left: -5px;
        display:flex;
        align-items:center;
        justify-content:center
      }

      .toast-content {
        flex-grow: 1;
        .title {
          font-size: 12px;
        }
        .message {
          font-size: 16px;
        }
      }

      .close {
        flex-shrink: 0;
        padding-left: 25px;

        & > div {
          color: white;
          display: inline-block;
          font-size: 21px;
          padding-right: 3px;
          padding-top: 1px;
        }
        $circle: 95px;
        svg {
          position: absolute;
          top: 50%;
          right: 10px;
          width: 40px;
          height: 40px;
          transform: rotateY(-180deg) rotateZ(-90deg) translateX(50%);

          circle {
            stroke-dasharray: $circle;
            stroke-dashoffset: 0px;
            stroke-linecap: round;
            stroke-width: 2px;
            opacity: 0.6;
            stroke: white;
            fill: none;
            animation: countdown 7s linear infinite forwards;
          }
        }
        @keyframes countdown {
          from {
            stroke-dashoffset: 0px;
          }
          to {
            stroke-dashoffset: $circle;
          }
        }
      }

    }

    .toast:not(:last-of-type) {
      margin-bottom: 10px;
    }

    @keyframes toast {
      0% {
        transform: translateX(20%);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes toast-close {
      0% {
        transform: translateX(0);
        opacity: 1;
      }
      100% {
        transform: translateX(-20%);
        opacity: 0;
      }
    }

  }

  .columns {
    display: flex;
  }
  .column {
    flex-grow: 1;
    flex-basis: 0;
    margin-right: 40px;
    &.small {
      margin-right: 20px;
      & > input {
        width: 100%;
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
  @media (max-width: 991px) {
    .columns {
      flex-direction: column;
      .column {
        margin-right: 0;
        flex-basis: initial;
      }
    }
  }

</style>

<style lang="scss">
  @media print {
    html, body {
      overflow: visible;
      height: auto;
      print-color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
    }
    #header, #navigation, .logo, .title, .top, .toasts, #mobile-header, .mobile-header {
      display: none !important;
    }
    button {
      display: none !important;
    }
    #app {
      display: block;
      width: 100%;
      height: auto;
    }
    .appcontent {
      padding: 0 !important;
      overflow: visible;
    }
    .panel {
      padding: 0 !important;
      .content-inner {
        padding-top: 0 !important;
      }
    }
  }
  .new-ui-popup {
    text-align: center;

    img {
      width: 100%;
      max-width: 250px;
      margin-bottom: 20px;
    }
  }
  .vdatetime-calendar__month {
    min-height: 311px;
  }
  .appcontent, #navigation {
    ::-webkit-scrollbar {
      width: 18px;
    }

     ::-webkit-scrollbar-thumb {
       box-shadow: inset 0 0 10px 10px #e5e5e5;
       border-radius: 10px;
       border: 6px transparent solid;
     }
     ::-webkit-scrollbar-track {
       background: transparent;
     }
  }

  #app {
    .vdatetime-popup {
      border-radius: 20px;
      font-family: "Roboto", sans-serif;
    }
    .vdatetime-popup__header {
      background: #fc6650;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
      background: #fc6650;
    }
    .vdatetime-popup__actions__button,
    .vdatetime-year-picker__item--selected,
    .vdatetime-time-picker__item--selected {
      color: #fc6650;
    }
  }
</style>
